import { UserModel } from '@steelbuy/ts-shared';

import { createEntityDataContext } from '../../util/provider/EntityDataProvider';

export const UserEntityData = createEntityDataContext<UserModel>();
